import { Container } from '@/atoms';
import { CardBanner, Grid, SliderProduct } from '@/molecules';
import { GridItem } from '@/molecules/grid/GridItem';
import { ProductBlock } from '@/organisms';
import { CardProductWordpress } from '@/templates';

import { cardBannerTransformer } from '@/lib/graphql/transformers';
import { isNumber, removeBaseURL, toArray } from '@/lib/utils';

const ProductosFlexible = ({
  bloque,
  id,
  productos,
  className,
  itemIndex,
}: any) => {
  const items = toArray(
    bloque.mostrarProductosRelacionados ? productos : bloque.productos,
  )
    .filter(Boolean)
    .map((item: any) => {
      const query = new URLSearchParams();

      if (bloque?.itemListId) query.set('itemListId', bloque.itemListId);
      if (bloque?.itemListName) query.set('itemListName', bloque.itemListName);

      return {
        ...item,
        uri:
          [...query].length > 0 ? `${item.uri}?${query.toString()}` : item.uri,
      };
    });

  return (
    <Container
      id={id}
      wrapper
      {...(className && { className })}
      as="section"
      {...(bloque.backgroundColorString
        ? {
            style: { backgroundColor: bloque.backgroundColorString },
            padding: 'px-4 py-8 md:py-8',
          }
        : {})}
    >
      <ProductBlock
        {...(bloque.titulo ? { title: bloque.titulo } : {})}
        {...(bloque.link?.link
          ? {
              link: {
                href: removeBaseURL(bloque.link.link.url) || '/',
                label: bloque.link.label,
                size: bloque.link.size,
                style: bloque.link.style,
              },
            }
          : {})}
        {...(bloque.description ? { description: bloque.description } : {})}
        {...(bloque.mostrarProductosRelacionados
          ? { title: 'Productos Relacionados' }
          : {})}
        productos={items}
        itemListId={bloque.itemListId}
        itemListName={bloque.itemListName}
        itemIndex={itemIndex}
        headingType={bloque.headingType}
      >
        {bloque.isGrid ? (
          <Grid {...(Number(bloque.itemsPorPagina) === 4 && { lg: 4 })}>
            {items.map((item: any, index: number) => (
              <GridItem key={index}>
                {'cpt_banner' in item ? (
                  <CardBanner
                    {...cardBannerTransformer(item.cpt_banner)}
                    key={index}
                  />
                ) : (
                  <CardProductWordpress
                    product={item}
                    itemListName={bloque.itemListName}
                    itemListId={bloque.itemListId}
                    itemIndex={index}
                    key={index}
                    numColumns={4}
                  />
                )}
              </GridItem>
            ))}
          </Grid>
        ) : (
          <SliderProduct
            perPage={
              isNumber(bloque.itemsPorPagina)
                ? Number(bloque.itemsPorPagina)
                : 6
            }
            {...(Number(bloque.itemsPorPagina) === 4
              ? {
                  breakpoints: {
                    1280: {
                      perPage: 4,
                    },
                    1024: {
                      perPage: 3,
                    },
                    768: {
                      padding: 40,
                      perPage: 2,
                    },
                    640: {
                      padding: 40,
                      perPage: 2,
                    },
                    450: {
                      padding: 40,
                      perPage: 1,
                    },
                  },
                }
              : {})}
            className="-mx-4 md:mx-0"
          >
            {items.map((item: any, index: number) =>
              'cpt_banner' in item ? (
                <CardBanner
                  {...cardBannerTransformer(item.cpt_banner)}
                  key={index}
                />
              ) : (
                <CardProductWordpress
                  product={item}
                  itemListName={bloque.itemListName}
                  itemListId={bloque.itemListId}
                  itemIndex={index}
                  key={index}
                  numColumns={4}
                />
              ),
            )}
          </SliderProduct>
        )}
      </ProductBlock>
    </Container>
  );
};

export default ProductosFlexible;

ProductosFlexible.displayName = 'FlexibleProductos';
